function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  id: "Path_58",
  "data-name": "Path 58",
  d: "M4048.116,2556.575l5.278,7.662-5.278,7.662",
  transform: "translate(-4047.704 -2556.291)",
  fill: "none",
  stroke: "#292929",
  strokeWidth: 1
});

function SvgArrowRightSimple(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 6.297,
    height: 15.892,
    viewBox: "0 0 6.297 15.892"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2LjI5NyIgaGVpZ2h0PSIxNS44OTIiIHZpZXdCb3g9IjAgMCA2LjI5NyAxNS44OTIiPgogIDxwYXRoIGlkPSJQYXRoXzU4IiBkYXRhLW5hbWU9IlBhdGggNTgiIGQ9Ik00MDQ4LjExNiwyNTU2LjU3NWw1LjI3OCw3LjY2Mi01LjI3OCw3LjY2MiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTQwNDcuNzA0IC0yNTU2LjI5MSkiIGZpbGw9Im5vbmUiIHN0cm9rZT0iIzI5MjkyOSIgc3Ryb2tlLXdpZHRoPSIxIi8+Cjwvc3ZnPgo=";
export { SvgArrowRightSimple as ReactComponent };